import { lazy } from 'react'

export const ReasonToJoinVariant1 = lazy(() => import('./ReasonToJoinVariant1'))
